document.addEventListener("DOMContentLoaded", function () {
  let searchDrawer = document.querySelector('[search-collections]');
            if (searchDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                       
                          BSS_B2B.observer.cartSubject.listenCartCheckout()
                        }
                    });
                });
                observer.observe(searchDrawer, {childList: true});
            }

  document.addEventListener('cart:rerendered', ()=> {
  if(BSS_B2B){
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
})
});